import ListadoOrdenCompra from "./ListadoOrdenCompraContainer";
export default ListadoOrdenCompra;